import React from 'react';
import { CompanyCount } from 'hooks/useRepresentantDashboard';
import { Container } from './styles';

interface DashboardCompanyBreakdownProps {
  id: string;
  title: string;
  total: number;
  items: CompanyCount[];
}

const DashboardCompanyBreakdown = ({ id, title, total, items }: DashboardCompanyBreakdownProps) => (
  <Container id={id} role="tooltip">
    <div className="breakdown-header">
      <span>{title}</span>
      <span>{total.toLocaleString('pt-BR')}</span>
    </div>
    <ul className="list-unstyled mb-0">
      {items.map((item) => (
        <li key={item.id}>
          <span className="breakdown-color" style={{ background: item.color }} aria-hidden="true" />
          <span className="breakdown-name">{item.name}</span>
          <span className="breakdown-value">
            {item.value === null ? '--' : item.value.toLocaleString('pt-BR')}
          </span>
        </li>
      ))}
    </ul>
  </Container>
);

export default DashboardCompanyBreakdown;
